module.exports = __webpack_public_path__ + "media/机器人实操基地12.e8c561b3.mp4";